import { ThemeParameters, RuntimeThemeParameters } from '../../types';

export const graphSkin = (theme: ThemeParameters, _parameters: RuntimeThemeParameters) => {
  switch (theme.baseThemeName) {
    case 'dark': {
      return {
        skinGlowThickness: 2,
      };
    }
    case 'high-contrast': {
      return {
        skinGlowThickness: 1,
      };
    }
    default: {
      return {
        skinGlowThickness: 1,
      };
    }
  }
};
